import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Currency = 'INR' | 'USD' | 'EUR';

interface CurrencyState {
    selectedCurrency: Currency;
    hasBeenManuallySet: boolean;
    locationFetched: boolean;
}

const initialState: CurrencyState = {
    selectedCurrency: 'INR',
    hasBeenManuallySet: false,
    locationFetched: false,
};

const currencySlice = createSlice({
    name: 'currency',
    initialState,
    reducers: {
        setCurrency: (state, action: PayloadAction<Currency>) => {
            state.selectedCurrency = action.payload;
            state.hasBeenManuallySet = true;
        },
        setCurrencyFromLocation: (state, action: PayloadAction<Currency>) => {
            state.selectedCurrency = action.payload;
            state.locationFetched = true;
        },
        setLocationFetched: (state, action: PayloadAction<boolean>) => {
            state.locationFetched = action.payload;
        }
    },
});

export const { setCurrency, setCurrencyFromLocation, setLocationFetched } = currencySlice.actions;
export default currencySlice.reducer;
